import effects from 'data/effects';

export default effects.reduce((map, effect) => {
  map[effect.name] = effect;
  return map;
}, {});
